import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Question from './Question';
import Homepage from './Homepage';
import Result from './Result';
import './styles/App.css';

export default function App() {
  const [result, setResult] = useState(0);

  function calculateResultPath() {
    if (result >= 0 && result <= 3) {
      return 'result1';
    } else if (result > 3 && result <= 6) {
      return 'result2';
    } else if (result > 6 && result <= 9) {
      return 'result3';
    } else if (result > 9 && result <= 12) {
      return 'result4';
    }
  }

  const data = [
    [
      {
        name: 'manual',
        text: 'Manual search and scrub',
        id: '1-manual-search-and-scrub',
      },
      { name: 'data', text: 'Data service', id: '1-data-service' },
      {
        name: 'multiple',
        text: 'Multiple data sources',
        id: '1-multiple-data-sources',
      },
      {
        name: 'warehouse',
        text: 'Data lake / warehouse',
        id: '1-data-lake-warehouse',
      },
    ],
    [
      {
        name: 'company',
        text: 'Company websites and spreadsheets',
        id: '2-company-websites-and-spreadsheets',
      },
      { name: 'crm', text: 'CRM (no integration)', id: '2-crm-no-integration' },
      {
        name: 'integrated',
        text: 'Integrated CRM and/or sales automation',
        id: '2-integrated-crm-and-or-sales-automation',
      },
      {
        name: 'business',
        text: 'Business intelligence and reporting tools',
        id: '2-business-intelligence-and-reporting-tools',
      },
    ],
    [
      {
        name: 'interns',
        text: 'Interns, analysts, and associates',
        id: '3-interns-analysts-and-associates',
      },
      {
        name: 'researchers',
        text: 'Researchers, business development managers',
        id: '3-researchers-business-developments-managers',
      },
      {
        name: 'sales',
        text: 'Sales operations and data analysts',
        id: '3-sales-operations-and-data-analysts',
      },
      {
        name: 'scientists',
        text: 'Data scientists and engineers',
        id: '3-data-scientists-and-engineers',
      },
    ],
  ];

  const peopleData = {
    image1: '/images/people-accent.svg',
    image2: '/images/tech.svg',
    image3: '/images/strategic.svg',
    image4: '/images/proprietary.svg',
    title: 'People and Networking',
    subtitle:
      'Deals come primarily inbound and are researched by interns or analysts who manually search the web, scrub whatever data they find, and track deals using spreadsheets.',
    nextTitle: 'Technology-assisted',
    nextLi1:
      'Build a diversified origination strategy and more robust deal pipeline with both inbound and directly-sourced opportunities.',
    nextLi2:
      'Master the ability to rapidly identify and vet opportunities using specific thesis criteria.',
    nextLi3:
      'Establish greater pipeline transparency, more standardized sourcing processes, and better deal flow control.',
  };

  const techData = {
    image1: '/images/people.svg',
    image2: '/images/tech-accent.svg',
    image3: '/images/strategic.svg',
    image4: '/images/proprietary.svg',
    title: 'Technology-Assisted',
    subtitle:
      'A dedicated Business Development team vets both inbound and directly-sourced opportunities against basic thesis criteria using a variety of data services and standalone CRM platform.',
    nextTitle: 'Strategic Capabilities',
    nextLi1:
      'Establish a more scalable, strategic, and systematic deal sourcing model that proactively and consistently generates relevant, high-quality deal flow.',
    nextLi2:
      'Enable an efficient and engaged BD team with a fully-integrated CRM, task automation, deal scoring, and more streamlined processes.',
    nextLi3:
      'Execute on more refined thesis criteria and more accurately measure, predict, and steer toward higher-value deal outcomes.',
  };

  const strategicData = {
    image1: '/images/people.svg',
    image2: '/images/tech.svg',
    image3: '/images/strategic-accent.svg',
    image4: '/images/proprietary.svg',
    title: 'Strategic Capabilities',
    subtitle:
      'Specialized data sources, integrated CRM, automation tools, and sales and data analysts power a highly scalable, systematic, and predictable direct-sourcing model.',
    nextTitle: 'Proprietary Advantage',
    nextLi1:
      'Integrate all the data in your organization in a cloud data warehouse that powers holistic, proprietary analyses.',
    nextLi2:
      'Use data science to build advanced scoring algorithms and machine learning and market modeling capabilities to improve deal outcomes and business agility.',
    nextLi3:
      'Generate increased proprietary deal flow, differentiated thesis criteria, and strategic wins the competition never sees coming.',
  };

  const proprietaryData = {
    image1: '/images/people.svg',
    image2: '/images/tech.svg',
    image3: '/images/strategic.svg',
    image4: '/images/proprietary-accent.svg',
    title: 'Proprietary Advantage',
    subtitle:
      'Specialized data sources, integrated CRM, automation tools, and sales and data analysts power a highly scalable, systematic, and predictable direct-sourcing model.',
    nextTitle: '?',
    nextLi1:
      'Integrate all the data in your organization in a cloud data warehouse that powers holistic, proprietary analyses.',
    nextLi2:
      'Use data science to build advanced scoring algorithms, machine learning and market modeling capabilities to improve deal outcomes and business agility.',
    nextLi3:
      'Generate increased proprietary deal flow, differentiated thesis criteria, and strategic wins the competition never saw coming.',
  };

  return (
    <div className='app-container'>
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route
          path='/1'
          element={
            <Question
              key={1}
              question='Where does the data your firm relies on for sourcing come from?'
              subtitle='Select all that apply. It can be more than one'
              active={1}
              answers={data[0]}
              result={result}
              setResult={setResult}
            />
          }
        />
        <Route
          path='/2'
          element={
            <Question
              key={2}
              question='What technology does your firm use for business development and deal sourcing?'
              subtitle='Select all that apply. It can be more than one'
              active={2}
              answers={data[1]}
              result={result}
              setResult={setResult}
            />
          }
        />
        <Route
          path='/3'
          element={
            <Question
              key={3}
              question='Who in your organization harnesses and/or manages dealmaking data and technology?'
              subtitle='Select all that apply. It can be more than one'
              active={3}
              answers={data[2]}
              result={result}
              setResult={setResult}
            />
          }
        />
        <Route
          path='/result1'
          element={
            <Result
              key={4}
              image1={peopleData.image1}
              image2={peopleData.image2}
              image3={peopleData.image3}
              image4={peopleData.image4}
              title={peopleData.title}
              subtitle={peopleData.subtitle}
              nextTitle={peopleData.nextTitle}
              nextLi1={peopleData.nextLi1}
              nextLi2={peopleData.nextLi2}
              nextLi3={peopleData.nextLi3}
              setResult={setResult}
            />
          }
        />
        <Route
          path='/result2'
          element={
            <Result
              key={5}
              image1={techData.image1}
              image2={techData.image2}
              image3={techData.image3}
              image4={techData.image4}
              title={techData.title}
              subtitle={techData.subtitle}
              nextTitle={techData.nextTitle}
              nextLi1={techData.nextLi1}
              nextLi2={techData.nextLi2}
              nextLi3={techData.nextLi3}
              setResult={setResult}
            />
          }
        />
        <Route
          path='/result3'
          element={
            <Result
              key={6}
              image1={strategicData.image1}
              image2={strategicData.image2}
              image3={strategicData.image3}
              image4={strategicData.image4}
              title={strategicData.title}
              subtitle={strategicData.subtitle}
              nextTitle={strategicData.nextTitle}
              nextLi1={strategicData.nextLi1}
              nextLi2={strategicData.nextLi2}
              nextLi3={strategicData.nextLi3}
              setResult={setResult}
            />
          }
        />
        <Route
          path='/result4'
          element={
            <Result
              key={7}
              image1={proprietaryData.image1}
              image2={proprietaryData.image2}
              image3={proprietaryData.image3}
              image4={proprietaryData.image4}
              title={proprietaryData.title}
              subtitle={proprietaryData.subtitle}
              nextTitle={proprietaryData.nextTitle}
              nextLi1={proprietaryData.nextLi1}
              nextLi2={proprietaryData.nextLi2}
              nextLi3={proprietaryData.nextLi3}
              setResult={setResult}
            />
          }
        />
      </Routes>
    </div>
  );
}
